import React from "react";
import styled from "styled-components";
import { inputStyle } from "./Input";
import { NumericFormat } from "react-number-format";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const ErrorText = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.colors.error};
`;

const StyledInput = styled.input`
  ${inputStyle}
  height: 33px;
`;

export const PercentageNumeric = ({
  value,
  onChange,
  error,
  variant,
  ...rest
}) => {
  return (
    <Wrapper>
      <NumericFormat
        value={value}
        onValueChange={(values) => {
          onChange(values.floatValue);
        }}
        customInput={StyledInput}
        suffix="%"
        {...rest}
        required
      />
      <ErrorText>{error || ""}</ErrorText>
    </Wrapper>
  );
};
